export const AddressLine2Label = "Apt., Suite, etc";

export const GoogleAddressComponentsFields = {
	StreetNumber: { name: "street_number", displayName: "Address 1" },
	Street: { name: "route", displayName: "Address 1" },
	// Workaround for cities which part of big agglomerations and don't have locality field from the Google API (e.g. some parts of the New York city)
	Neighborhood: { name: "neighborhood", displayName: "City" },
	SubCity: { name: "sublocality_level_1", displayName: "City" },
	City: { name: "locality", displayName: "City" },
	Region: { name: "administrative_area_level_1", displayName: "State" },
	Country: { name: "country", displayName: "Country" },
	CountryCode: { name: "country_code", displayName: "Country Code" },
	PostalCode: { name: "postal_code", displayName: "Zip" },
	LongName: { name: "long_name", displayName: "" },
	ShortName: { name: "short_name", displayName: "" },
};

export const GoogleAddressDetailsFields = {
	AddressComponents: "address_components",
	FormattedAddress: "formatted_address",
	Geometry: "geometry",
	Location: "location",
};

export const GoogleAddressPredictionFields = {
	Predictions: "predictions",
	Description: "description",
	PlaceId: "place_id",
};

export const GoogleAddressOptionFields = {
	Label: "label",
	PlaceId: "placeId",
	Address: "address",
	Lat: "lat",
	Lng: "lng",
};
